"use client";

import Section from "@/components/static/Section";
import React from "react";
import parse from "html-react-parser/lib/index";
import { cn } from "@/lib/utils";
import Download from "@/components/static/DownloadCard";
import useSWR from "swr";
import { useState, useEffect } from "react";
import Loader from "@/components/static/Loader";
import Headline from "@/components/static/Headline";
import { DownloadProps } from "@/lib/types";
import Button from "@/components/static/Button";
import Text from "@/components/static/Text";
import { SectionProps, HeadlineProps, TermProps, ImageProps, ButtonProps } from "@/lib/types";

type Content = {
    acf_fc_layout: string;
    icon: {
        url: string;
        alt: string;
        width: number;
        height: number;
    };
    headline: HeadlineProps;
    text: string;
    settings: { download_cat: number } & SectionProps;
};

export default function Event_5({ content }: { content: Content }) {
    const [total, setTotal] = useState(0);
    const [posts, setPosts] = useState<DownloadProps[]>([]);
    const [perPage, setPerPage] = useState(99);
    const [category, setCategory] = useState<boolean | number>(false);

    content.settings?.download_cat &&
        category != content.settings?.download_cat &&
        setCategory(content.settings?.download_cat);

    const { data: categoriesData } = useSWR<TermProps[]>(
        `wp/v2/download_cat?_fields=name,slug,id`,
        async (url: string) => {
            const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}${url}`, {});
            const data = await response.json();
            return data;
        }
    );

    const { data, isLoading } = useSWR<{ data: DownloadProps[]; total: number }>(
        category
            ? `wp/v2/download?per_page=${perPage}&download_cat=${category}&_embed=&acf_format=standard`
            : `wp/v2/download?per_page=${perPage}&_embed=&acf_format=standard`,
        async (url: string) => {
            const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}${url}`, {});
            const data = await response.json();
            return {
                data: data,
                total: parseInt(response.headers.get("x-wp-total") || "0"),
            };
        }
    );

    useEffect(() => {
        if (data) {
            setPosts(data.data);
            setTotal(data.total);
        }
    }, [data]);

    return (
        <Section dataComponent='Event_5' settings={content.settings} preventAnimation={true}>
            <div className='container'>
                {content.headline.topline ||
                    (content.headline.title && (
                        <div className='flex flex-col max-w-lg mb-20'>
                            <Headline
                                align='left'
                                tag={content.headline.tag}
                                topline={content.headline.topline}
                            >
                                {content.headline.title}
                            </Headline>
                            {content.text && (
                                <Text className='prose md:text-md'>{parse(content.text)}</Text>
                            )}
                        </div>
                    ))}
                <div className=''>
                    {!content.settings?.download_cat && categoriesData && (
                        <div className='text-lg text-textSecondary flex flex-wrap gap-x-4 mb-14'>
                            <button
                                className={cn(
                                    "px-2 rounded-[4px] hover:text-on-primary hover:bg-brand-light hover:text-white transition",
                                    !category && "bg-brand-light text-white"
                                )}
                                onClick={() => {
                                    setCategory(false);
                                }}
                            >
                                {"Alle"}
                            </button>
                            {categoriesData.map((cat, index) => {
                                return (
                                    <button
                                        className={cn(
                                            "px-2 py-1 rounded-[4px] hover:bg-brand-light hover:text-white transition",
                                            category === cat.id && "bg-brand-light text-white"
                                        )}
                                        onClick={() => {
                                            setCategory(cat?.id);
                                        }}
                                        key={index}
                                    >
                                        {cat?.name}
                                    </button>
                                );
                            })}
                        </div>
                    )}
                    {posts && (
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
                            {posts.map((post, index: number) => {
                                return <Download key={index} content={post} />;
                            })}
                        </div>
                    )}
                    {isLoading && (
                        <div className='flex justify-center m-8'>
                            <Loader color='#005DA3' text='Downloads werden geladen...' />
                        </div>
                    )}
                    {posts && posts.length < total && (
                        <div
                            className='mt-2'
                            onClick={() => {
                                setPerPage(perPage + 3);
                            }}
                        >
                            <Button as='button' type='primary'>
                                {"Mehr laden"}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Section>
    );
}

/* import InnerComp from "./inner";

export default async function Event_5({ content }: { content: any }) {
	return <InnerComp content={content} />;
} */
